import type { AuthUser } from '@/modules/auth/schemas/oauth';

import type { ViewFilter } from '../types';

export const assignedToMeViewFilter = (user: Pick<AuthUser, 'id' | 'email' | 'name'>): ViewFilter => ({
    id: user.id,
    email: user.email,
    name: user.name,
    type: 'user',
});
